var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGg = function SvgIconGg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-gg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F9",
    fillRule: "evenodd",
    d: "M12.712 6.889a4.041 4.041 0 0 0-2.608-.953A4.067 4.067 0 0 0 6.04 10a4.068 4.068 0 0 0 4.063 4.062c.814.03 1.619-.17 2.326-.574l2.286 1.762a6.833 6.833 0 0 1-4.612 1.625 6.883 6.883 0 0 1-6.875-6.875c0-1.059.245-2.103.716-3.051a6.867 6.867 0 0 1 10.81-2.006zm3.986 1.86h-6.563v2.812h3.719a3.352 3.352 0 0 1-1.424 1.926l2.287 1.762c1.46-1.31 2.32-3.443 1.98-6.5",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-gg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconGg;